import * as React from 'react';
import '../css/input-text.sass';
import Hat, { HatType } from './Hat';
import shouldFlipBG from '../utils/should-flip-bg';

interface DisplayFieldProps {
  name: string;
  value?: React.ReactNode;
  iconPath?: string;
  id: string;
  label?: string;
  hasError?: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  setRef?: any;
  hat?: HatType[];
  additionalText?: string;
}

interface DisplayFieldState {
  flipBg: string;
}

export default function DisplayField(props: DisplayFieldProps) {
  const style: any = {};
  const { theme = 'day' } = props;
  if (props.iconPath) {
    style.paddingLeft = '40px';
  }

  const inputEl: any = React.useRef(null);

  const [state, setState] = React.useState<DisplayFieldState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputEl, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
    if (props.setRef !== undefined) {
      props.setRef(inputEl);
    }
  }, []);

  return (
    <>
      {props.hat &&
        props.hat.length > 0 &&
        props.hat[0] &&
        props.hat[0].message && <Hat hat={props.hat} />}
      <div
        ref={inputEl}
        className={`input-field display-field complete-state  read-only-text ${theme}${
          props.hasError ? ' error' : ''
        }
            ${props.label ? '' : ' no-label'}${state.flipBg}`}
      >
        <div className="text">
          {!!props.label && <label htmlFor={props.id}>{props.label}</label>}
          {!!props.iconPath && (
            <div
              className="icon"
              style={{
                marginRight: '8px',
                backgroundImage: `url(${props.iconPath})`
              }}
            ></div>
          )}
          <span
            id={props.id}
            className={`input-value display-field-value ${
              props.hasError ? 'invalid' : ''
            }`}
            aria-invalid={props.hasError}
          >
            {props.value}
          </span>
          {!!props.additionalText && (
            <span className="input-value display-field-value additionalText">
              {props.additionalText}
            </span>
          )}
        </div>

        {props.hasError && props.errors}
      </div>
    </>
  );
}
